import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=16f95ed5&functional=true&"
var script = {}
import style0 from "./TitleBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports